"use client";

import { Button } from "@shared/src/components/ui/button";
import { useAuthStore } from "@shared/src/stores/useAuthStore";
import { useRouter } from "next/navigation";

export function WhitelistCheckView() {
  const router = useRouter();
  const { closeAndResetAuthModal, setAccountLinkingStatus, setSelectedView } = useAuthStore();

  const handleApplyWhitelist = () => {
    router.push("/whitelist");
    closeAndResetAuthModal();
  };

  const handleExploreTestnet = () => {
    router.replace("https://testnet.iexchange.global");
    closeAndResetAuthModal();
  };

  const handleLinkWallet = async () => {
    setAccountLinkingStatus("linking");
    setSelectedView("social");
  };

  return (
    <div className="flex flex-col items-center w-full">
      {/* Desktop and Mobile Header */}
      <div className="w-full text-center mb-8">
        <p className="text-text-secondary">This address has not been whitelisted for iExchange mainnet.</p>
      </div>

      {/* Options Container */}
      <div className="w-full space-y-4 max-w-md">
        {/* Apply for Whitelist Button */}
        <Button
          onClick={handleApplyWhitelist}
          variant="primary"
          size="lg"
          radius="full"
          width="full"
          className="flex items-center justify-center gap-2"
        >
          <img src="/images/icons/whitelist.svg" alt="Whitelist" width={24} height={24} className="opacity-80" />
          Apply for Whitelist
        </Button>

        {/* Explore Testnet Button */}
        <Button
          onClick={handleExploreTestnet}
          variant="tertiary"
          size="lg"
          radius="full"
          width="full"
          className="flex items-center justify-center gap-2"
        >
          <img src="/images/icons/explore.svg" alt="Explore" width={24} height={24} className="opacity-80" />
          Explore Testnet
        </Button>

        {/* Divider */}
        <div className="relative py-4">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-border-tertiary"></div>
          </div>
          <div className="relative flex justify-center">
            <span className="px-4 text-text-tertiary text-small bg-transparent">
              Already have a whitelisted account on iExchange?
            </span>
          </div>
        </div>

        {/* Link Wallet Button */}
        <Button
          onClick={handleLinkWallet}
          variant="secondary"
          size="lg"
          radius="full"
          width="full"
          className="flex items-center justify-center gap-2"
        >
          <img src="/images/icons/link.svg" alt="Link" width={24} height={24} className="opacity-80" />
          Link this Wallet
        </Button>
      </div>
    </div>
  );
}
